import { gray2, gray4, mainColor } from "assets/styleUtils";
import { getCompanyReviewDetail, ICompanyReview } from "data/company";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function CompanyReviewDetailPage() {
  // TODO: props 구조분해
  const props = useParams();
  const [review, setReview] = useState<ICompanyReview>();
  const [currentPage, setCurrentPage] = useState(0);

  async function getReview() {
    try {
      const {
        data: { result },
      } = await getCompanyReviewDetail({
        review_no: String(props?.review_no),
        contructor_no: String(props.contructor_no),
      });
      if (result) {
        setReview(result);
      }
    } catch (error) {
      console.log("getReview error", error);
    }
  }

  useEffect(() => {
    getReview();
  }, [props.review_no]);

  return (
    <>
      <div

      // contentContainerStyle={{
      //   paddingTop: 16 * REM,
      //   paddingBottom: 40 * REM,
      // }}
      >
        <div style={{ padding: "16px 16px" }}>
          <div
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                lineHeight: "18px",
              }}
            >
              <img
                src={
                  review?.user.profile_img
                    ? review?.user.profile_img
                    : "/images/defaultImg.png"
                }
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "16px",
                  marginRight: "12px",
                }}
              />
              <div>
                <div style={{ color: gray2 }}>{review?.user.nickname}</div>
                <div style={{ color: gray4 }}>{review?.createdAt}</div>
              </div>
            </div>
            {/* TODO */}
            {/* <Profile
                style={{marginBottom: 16 * REM}}
                uri={review?.review?.user.profile_img}
                name={review?.review?.user.nickname}
                date={review?.createdAt}
                nameBadge={
                  review?.contract_yn === 'Y' ? (
                    <div
                      style={{
                        ...center,
                        width: 33 * REM,
                        height: 20 * REM,
                        backgroundColor: mainColor,
                        borderRadius: 4 * REM,
                        marginLeft: 8 * REM,
                      }}>
                      <div size={10 * REM} weight="500" color={white}>
                        인증
                      </div>
                    </div>
                  ) : undefined
                }
              /> */}
          </div>
          <div>
            <div style={{ padding: "16px 0", lineHeight: "25.2px" }}>
              {review?.content}
            </div>
          </div>

          <>
            {(review?.photo || []).map((value, i) => (
              <img
                src={value.img_url}
                style={{ width: "100%", height: "100%", marginBottom: "16px" }}
              />
            ))}
          </>
          {/* TODO */}
          {/* {!!(review?.photo && review?.photo.length) && (
              <PagerView
                showPageIndicator={true}
                style={styles.contentImage}
                onPageSelected={e => setCurrentPage(e.nativeEvent.position)}>
                {review?.photo.map((value, i) => {
                  return (
                    <Press
                      withoutFeedback={true}
                      onPress={() =>
                        navigation.push(ScreenId.IMAGE_MODAL, {
                          images:
                            review?.photo?.map(({img_url}) => ({
                              url: img_url,
                            })) || [],
                          index: i,
                        })
                      }>
                      <FastImage
                        key={value.no}
                        style={{width: '100%', height: '100%'}}
                        source={{
                          uri: value.img_url,
                        }}
                      />
                    </Press>
                  );
                })}
              </PagerView>
            )} */}
        </div>
      </div>
    </>
  );
}
